import { render, staticRenderFns } from "./pet-address-form.vue?vue&type=template&id=63b9cb4c&scoped=true&"
import script from "./pet-address-form.vue?vue&type=script&lang=js&"
export * from "./pet-address-form.vue?vue&type=script&lang=js&"
import style0 from "./pet-address-form.vue?vue&type=style&index=0&id=63b9cb4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b9cb4c",
  null
  
)

export default component.exports